import React, { useEffect, useState } from 'react';
import { useTypedSelector } from '../../../../../hooks/useTypeSelector';
import { axiosInstance } from '../../../../../config/axiosInstance';
import { globalEnv } from '../../../../../config/baseConfig';
import { useQuery } from 'react-query';
import Pagination from '../../../../Tables/pagination';
import { DataNotFoundAnimation } from '../../../../Utils/ErrorAnimations/dataNotFoundAnim';
import TableLoadingSkeleton from '../../../../Utils/LoadingAnimations/TableLoadingSkeleton';
import { useParams } from 'react-router-dom';

export function ContactedUsersList() {
	const [page, setPage] = useState(1);
	const { campaignId } = useParams();

	const [dimensions, setDimensions] = useState({
		width: window.innerWidth,
		height: window.innerHeight
	});
	useEffect(() => {
		function handleResize() {
			setDimensions({
				width: window.innerWidth,
				height: window.innerHeight
			});
		}
		window.addEventListener('resize', handleResize);
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	const { ACCESS_TOKEN } = useTypedSelector((state) => state.auth);

	const { data, isSuccess, isLoading, isFetching, isError } = useQuery(
		['usersList', page],
		() => fetchContactedUsersData(),
		{
			cacheTime: 0,
			keepPreviousData: false,
			staleTime: 5000,
			refetchOnWindowFocus: false
		}
	);

	const fetchContactedUsersData = async () => {
		const config = {
			headers: {
				Authorization: 'Bearer ' + ACCESS_TOKEN
			}
		};
		const url =
			campaignId != null
				? `/outreach/campaign/${campaignId}/contacted-adrs`
				: '/outreach/campaign/all-contacted-adrs';

		const { data } = await axiosInstance.get(
			globalEnv.BASE_URL + url + '?page=' + page,
			config
		);
		return data;
	};

	return (
		<section className="pl-16 pt-16">
			<div className="p-3">
				{isSuccess && (
					<div>
						<div className="overflow-x-auto ">
							{data.data.map((item: any) => (
								<div className="relative group bg-gray-300 dark:bg-gray-700 mt-2 w-full h-fit flex flex-col items-start rounded-lg overflow-hidden ">
									<div
										className="w-full h-full flex items-start align-middle px-4 py-3 dark:hover:bg-gray-600 hover:bg-gray-400 cursor-pointer"
										// onClick={() => navigate(`../user/${id}`)}
									>
										<div className="font-medium text-sm mt-0.5 text-gray-800 dark:text-white ">
											{item}
										</div>
									</div>
								</div>
							))}
						</div>
					</div>
				)}
				{isFetching || isLoading ? (
					<div>
						<TableLoadingSkeleton />
						<TableLoadingSkeleton />
						<TableLoadingSkeleton />
						<TableLoadingSkeleton />
						<TableLoadingSkeleton />
						<TableLoadingSkeleton />
						<TableLoadingSkeleton />
						<TableLoadingSkeleton />
						<TableLoadingSkeleton />
						<TableLoadingSkeleton />
						<TableLoadingSkeleton />
					</div>
				) : isError ? (
					<div className="h-full ml-0 ">
						<div className=" flex flex-col mx-auto my-auto text-center align-middle overflow-clip h-full ">
							<div className="mx-auto my-auto self-center">
								<div className="min-h-16">
									<DataNotFoundAnimation height={dimensions.height / 1.5} />
								</div>
								<h3 className="lg:text-2xl text-xl font-bold dark:text-gray-200 text-gray-700 -mt-8">
									{"Couldn't find the data you're looking for!"}
								</h3>
							</div>
						</div>
					</div>
				) : (
					<Pagination
						itemsPerPage={data.meta.limit}
						totalCount={data.meta.total}
						totalPages={data.meta.pages}
						currentPage={page}
						setPage={setPage}
					/>
				)}
			</div>

			{/* <ReactQueryDevtools initialIsOpen /> */}
		</section>
	);
}
